export enum RoleEnum {
    Admin = 1
}



// WEBPACK FOOTER //
// ./src/app/core/enums/role.enum.ts